import { EventStatus } from '~/gamification/types/gamification.types'
import { QUIZ_ANSWER_RATING } from '~/get-started/us-onboarding/consts/stepsConfig'
import { UserCategory } from '~/get-started/us-onboarding/consts/types'
import { AdvancedQuizQuestion, MappingQuizData, MappingQuizUserAnswer, QuizQuestion } from '~/shared/types/Quiz.types'

export enum QUIZ_VIEW {
  INITIAL = 'INITIAL',
  YES_NO_QUESTION = 'YES_NO_QUESTION',
  SUBJECT_RATING = 'SUBJECT_RATING',
  IS_COMPLETE = 'COMPLETE',
  AWARD = 'AWARD',
  ADVANCED_QUIZ = 'ADVANCED_QUIZ',
  APPLY_HERE = 'APPLY_HERE',
  HOMEBASE = 'HOMEBASE',
  QUEST = 'QUEST',
  CREATE_LEARNING_PATH = 'CREATE_LEARNING_PATH',
  REGISTER = 'REGISTER',
}

export enum QUEST {
  THE_MULTIPLICATION_GAME = 'quest-the-multiplication-game',
}

export enum COLLECTION_LIST {
  ALL_ITEMS = 'all-items',
  MATH_DRILLS = 'math-drills',
  COMPETITION = 'competition',
  BOOTCAMP = 'bootcamp',
}

export enum QUIZ_SUBJECT {
  THE_MULTIPLICATION_TABLE = 'quiz-subject-the-multiplication-table',
  FRACTIONS = 'quiz-subject-fractions',
  PERCENT = 'quiz-subject-percent',
  POWERS = 'quiz-subject-powers',
  BASIC_ALGEBRA = 'quiz-subject-basic-algebra',
  PARENTHESES = 'quiz-subject-parentheses',
  FACTORIZATION = 'quiz-subject-algebraic-factorization',
  EQUATIONS = 'quiz-subject-equations',
  FUNCTIONS = 'quiz-subject-functions',
}

export enum QUIZ_SUBJECT_ADVANCED {
  PI = 'quiz-subject-advanced-pi',
  PROBABILITY = 'quiz-subject-advanced-probability',
  SETS_OF_NUMBERS = 'quiz-subject-advanced-sets-of-numbers',
  QUADRATIC_EQUATIONS = 'quiz-subject-advanced-quadratic-equations',
  LOGARITHMS = 'quiz-subject-advanced-logarithms',
  TRIGONOMETRY = 'quiz-subject-advanced-trigonometry',
  VECTORS = 'quiz-subject-advanced-vectors',
  SERIES = 'quiz-subject-advanced-series',
  DERIVATIVES = 'quiz-subject-advanced-derivatives',
  INTEGRALS = 'quiz-subject-advanced-integrals',
  DIFFERENTIAL_EQUATIONS = 'quiz-subject-advanced-differential-equations',
  PROOFS = 'quiz-subject-advanced-proofs',
}

export type Quest_ID = QUEST | QUIZ_SUBJECT | QUIZ_SUBJECT_ADVANCED

export enum QUIZ_SUBJECT_RATING {
  VERY_POOR = 1,
  POOR = 2,
  NEUTRAL = 3, // <- Not using this rating as per business request as this option is confusing from the user perspective
  WELL = 4,
  VERY_WELL = 5,
}

export enum RATING_TYPE {
  ILP = 'ilp',
  CURRICULUM = 'curriculum',
}

export interface RatingItem {
  emoji: string
  rating: QUIZ_SUBJECT_RATING | QUIZ_ANSWER_RATING
  i18nKey?: string | Record<UserCategory, string>
  isSmallEmoji?: boolean
}

export const RATING_ITEMS: RatingItem[] = [
  { emoji: 'icons/onboarding-quiz-emojis/thumb-down.png', rating: QUIZ_SUBJECT_RATING.VERY_POOR },
  { emoji: 'icons/onboarding-quiz-emojis/thumb-down.png', rating: QUIZ_SUBJECT_RATING.POOR, isSmallEmoji: true },
  { emoji: 'icons/onboarding-quiz-emojis/thumb-up.png', rating: QUIZ_SUBJECT_RATING.WELL, isSmallEmoji: true },
  { emoji: 'icons/onboarding-quiz-emojis/thumb-up.png', rating: QUIZ_SUBJECT_RATING.VERY_WELL },
]

export interface QuestData {
  id: Quest_ID
  status: EventStatus
  nextQuest?: Quest_ID
}

export enum CHAMPIONSHIP_IDS {
  CHAMPIONSHIP_2021 = 'championship-2021',
}

export interface GemsList {
  red: number
  green: number
  blue: number
}
export interface homebaseQuizState {
  quizState: MappingQuizUserAnswer[] | []
  quizSubject: QuizQuestion | undefined
  advancedSubjects: AdvancedQuizQuestion
  quizView?: QUIZ_VIEW
  mappingQuizData: MappingQuizData | undefined
  completedQuizes: number
}
